// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const translations = {
  exit: 'Выход',
  equipmentCatalog: 'Каталог оборудования',
  more: 'Подробнее',
  fieldName: 'Название компании',
  fieldEmail: 'Email',
  subscribe: 'Подписаться',
  news: 'Новости',
  productSingularNominative: 'товар',
  productSingularGenitive: 'товара',
  productPluralGenitive: 'товаров',
  daySingularNominative: 'день',
  daySingularGenitive: 'дня',
  dayPluralGenitive: 'дней',
  lineSingularNominative: 'строка',
  lineSingularGenitive: 'строки',
  linePluralGenitive: 'строк',
  rowSingularNominative: 'строке',
  rowSingularGenitive: 'строках',
  rowPluralGenitive: 'строках',
  subscribeInfo: 'Код подтверждения отправлен на ваш Email. Перейдите по ссылке в письме для активации подписки',
  subscribeReject: 'Запрос отклонен',
  subscribeExist: 'Вы уже подписаны на нашу рассылку',
  profile: 'Профиль',
  myCompany: 'Моя компания',
  offerContract: 'Договор оферты',
  name: 'Имя',
  surname: 'Фамилия',
  patronymic: 'Отчество',
  region: 'Регион:',
  change_pass: 'Изменение пароля',
  legalShort: 'Юр. лицо',
  legal: 'Юридическое лицо',
  deleteTokenConfirm: 'Вы действительно хотите удалить токен?',
  multiplicity: 'Кратность',
  packageBy: 'Упаковка по',
  tokenError: 'При генерации токена возникла ошибка. Скорее всего токен с такими параметрами уже существует',
  manufacturerCode: 'Артикул',
  photo: 'Фото',
  articulName: 'Код / Наименование',
  manufacturerHeader: 'Бренд',
  manufacturerHeaderShowcase: 'Производитель',
  manufacturerSeriesHeader: 'Серия',
  status: 'Статус',
  supplier: 'Поставщик',
  supply: 'Поставка',
  priceRur: 'Цена, ₽',
  toCart: 'В корзину',
  inCart: 'в корзине',
  sum: 'Сумма',
  chooseProducts: 'Подбор товара',
  registration: 'Регистрация',
  remove: 'Удалить',
  tokenCreated: 'Токен создан',
  confirmClearCart: 'Вы действительно хотите очистить корзину',
  confirmDeleteOffer: 'Вы действительно хотите удалить КП',
  confirmArchiveOffer: 'Вы действительно хотите архивировать КП',
  confirmRestoreOffer: 'Вы действительно хотите восстановить КП',
  confirmDeleteArchiveOffers: 'Вы действительно хотите удалить все КП из архива',
  confirmRepairArchiveOffers: 'Вы действительно хотите восстановить все КП из архива',
  requiredValidationMsg: 'Это поле обязательно для заполнения',
  switchLightTheme: 'включить светлую тему',
  switchDarkTheme: 'включить темную тему',
  apiTokens: 'API токены',
  schedule: 'ПН - ПТ 9.00 - 18.00',
  holidays: 'СБ, ВС выходной',
  cart: 'Корзина',
  bc: {
    home: 'Главная',
    news: 'Новости',
    catalog: 'Подбор товара',
    specifications: 'Спецификации',
    offers: 'Коммерческие предложения',
    orders: 'Заказы',
    profile: 'Профиль',
    tokens: 'API Токены',
    company: 'Моя компания',
    acts: 'Акты сверки',
    promotions: 'Акции'
  },
  titles: {
    adCampaigns: 'Акции',
    orders: 'Заказы',
    specifications: 'Спецификации',
    company: 'Моя компания',
    acts: 'Акты сверки',
    dept: 'Взаиморасчеты',
    offers: 'Коммерческое прежложение',
    news: 'Новости',
    delivery: 'Доставка',
    cart: 'Корзина',
    account: 'Профиль',
    tokens: 'API Токены',
    offer: 'Договор Оферты',
    notificationsCustomer: 'Оповещения',
    faq: 'Вопросы и ответы'
  },
  availability: 'Наличие',
  supplyTerm: 'Поставка, дней',
  deleteAllSpecifications: 'Удалить все спецификации',
  archiveSelectedSpecifications: 'Архивировать выбранные спецификации',
  restoreSelectedSpecifications: 'Восстановить выбранные спецификации',
  chooseTheFile: 'Выберите файл',
  chooseTheLogo: 'Выберите логотип',
  profileUpdated: 'Профиль обновлен',
  successfully: 'успешно',
  archiveSpecification: 'Архивировать спецификацию',
  restoreSpecification: 'Восстановить спецификацию',
  settingsUpdated: 'Настройки обновлены',
  amount: 'Количество',
  title: 'Название',
  description: 'Описание',
  date: 'Дата',
  author: 'Автор',
  positions: 'Позиций',
  totalSum: 'Сумма, ₽',
  moveToSpecification: 'Перенести в спецификацию',
  copyToSpecification: 'Копировать в спецификацию',
  contractHeader: 'Контракт',
  act: 'Акт сверки',
  period: 'Период',
  create: 'Создать',
  edit: 'Редактировать',
  increasePercent: 'Увеличить на процент',
  decreasePercent: 'Уменьшить на процент',
  increaseValue: 'Увеличить на фиксированное значение',
  decreaseValue: 'Уменьшить на фиксированное значение',
  restorePrice: 'Сбросить цены до изначальных',
  productName: 'Наименование',
  promotions: 'Акции',
  import: 'Импортировать',
  analog: 'Аналог',
  related: 'Связанные',
  confirmDeleteAct: 'Вы действительно хотите удалить Акт',
  actPeriod: 'Период акта сверки',
  actCreated: 'Дата формирования акта сверки',
  actRequested: 'Акт запрошен',
  downloadAct: 'Скачать акт сверки',
  delete: 'Удалить',
  notificationSubject: 'Тема сообщения',
  notificationType: 'Тип события',
  notificationTransport: 'Транспорт события',
  sucessPriceList: 'Успешно',
  priceListRequestAccepted: 'Запрос на генерацию прайс-листа сформирован, прайс-лист будет отправлен на ваш email',
  cartShareLinkCreated: 'Ссылка скопирована в буффер обмена. Вы можете передать эту ссылку для того чтоб поделиться корзиной',
  notificationCustomer: 'Системные оповещения',
  catalogHeader: 'Каталог',
  countryHeader: 'Страна',
  articulHeaderShowcase: 'Наименование'
};
